<template >
    <div @mouseout="$emit('mouseover')" class="hover-modal" @click.self="close()">
           <transition name="slide-fade">
               <div v-if="init" class="card kne-modal" >
                   <div class="card-block px-0 pt-0">
                       <div >
                           <heat-map 
                           :coordinates="data" 
                           :zoneParamToShow="{ label: '', value: '' }"
                           :zoneToBeHighlighted="hoveredZone"
                           >
                        </heat-map>
                       </div>
                   </div>
               </div>
           </transition>
       </div>
</template>


<script>
import HeatMap from '../Other-components/HeatMap.vue'

export default {
   name: 'HeatMapModal',
   data () {
       return {
           data: [],
           init: false
       }
   },
   components: {
       HeatMap
   },
   props: {
       coordinates: {
           type: Array,
           required: true
       },
       currentZone: {
           type: String,
           required: true
       },
       hoveredZone: {
           type: String,
           required: true
       }
   },
   created () {
       this.setZonesData()
   },
   methods: {
    setZonesData () {
           let data = {
               type: 'FeatureCollection',
               features: []
           }
           const features = this.coordinates
               .filter(zone => zone.zoneName === this.currentZone || zone.zoneName === this.hoveredZone)
               .map(zone => {
                   return {
                       type: 'Feature',
                       properties: {
                           name: zone.zoneName
                       },
                       geometry: {
                           type: 'Polygon',
                           coordinates: [
                               zone.coordinates
                           ]
                       }
                   }
               })
           data.features = features
           this.data = data
       },
       close: function (origin) {
         if (this.closableBackdrop) this.$emit('close-request')
         if (origin === 'x') this.$emit('close-request')
       },
       closeOnESC (e) {
           if (e.keyCode === 27) this.close('x')
       }
     },
     mounted () {
       this.init = true
       document.body.style.overflow = 'hidden'
     },
     destroyed () {
       document.body.style.overflow = 'auto'
     }
}
</script>

<style scoped>
h3 {
    border-radius: 3px;
}

.card {
    border: none;
    /*min-height: 32rem;*/
}

.close {
    color: white;
    font-size: 2rem;
}

.hover-modal {
    border: 1px solid rgba(128, 128, 128, 0.438);
    position: absolute;
    right: 0;
    width: 600px;
    z-index: 2000 !important;
    max-height: 500px;
    height: 100%;
}

.kne-modal {
    top: -120px;
    background: transparent;
    padding: 0px;
    border-radius: 3px;
    width: 730px;
}

.card-block {
    overflow-y: hidden;
    overflow-x: hidden;
}

.card-title>span {
    color: rgba(19, 19, 19, 0.6);
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 500ms;
}

.slide-fade-enter,
.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(20px);
}
</style>
